import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { companyInfo } from '../data/mockData';

const SEO = ({ 
  title, 
  description, 
  keywords, 
  image, 
  type = 'website'
}) => {
  const location = useLocation();
  const siteUrl = typeof window !== 'undefined' ? window.location.origin : 'https://busecurity.com';
  const fullUrl = `${siteUrl}${location.pathname}`;
  const ogImage = image || `${siteUrl}/og-image.jpg`;
  const metaDescription = description || companyInfo.description;
  const metaTitle = title ? `${title} | ${companyInfo.name}` : `${companyInfo.name} - ${companyInfo.tagline}`;
  const metaKeywords = keywords || 'security guards, security services, Miami security, Florida security, armed guards, unarmed guards, event security, mobile patrol, surveillance monitoring';

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{metaTitle}</title>
      <meta name="title" content={metaTitle} />
      <meta name="description" content={metaDescription} />
      <meta name="keywords" content={metaKeywords} />
      <meta name="author" content={companyInfo.name} />
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      <meta name="revisit-after" content="7 days" />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={metaTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content={companyInfo.name} />
      <meta property="og:locale" content="en_US" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={metaTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={ogImage} />
      
      {/* Additional SEO */}
      <meta name="geo.region" content="US-FL" />
      <meta name="geo.placename" content="Miami" />
      <meta name="geo.position" content="25.7617;-80.1918" />
      <meta name="ICBM" content="25.7617, -80.1918" />
      
      {/* Business Information */}
      <meta name="contact" content={companyInfo.email} />
      <meta name="phone" content={companyInfo.phone} />
      <meta name="address" content={companyInfo.address} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={fullUrl} />
    </Helmet>
  );
};

export default SEO;
